import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiKey, FiLogIn, FiLoader, FiAlertCircle, FiShield } = FiIcons;

const ADMIN_PASSWORD = 'burger2024'; // Simple password for demo purposes

const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  // Check if already logged in from localStorage
  useEffect(() => {
    const adminAuth = localStorage.getItem('adminAuth');
    if (adminAuth && adminAuth === 'true') {
      setIsLoggedIn(true);
      onLoginSuccess();
    }
  }, [onLoginSuccess]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    
    // Simulate API call with timeout
    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        // Store authentication in localStorage
        localStorage.setItem('adminAuth', 'true');
        setIsLoggedIn(true);
        onLoginSuccess();
      } else {
        setError('Falsches Passwort. Bitte versuchen Sie es erneut.');
      }
      setIsSubmitting(false);
    }, 800); // Simulate network delay
  };
  
  if (isLoggedIn) {
    return null; // Don't render anything if already logged in
  }
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden"
      >
        <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white p-8 text-center">
          <SafeIcon icon={FiShield} className="text-5xl mx-auto mb-4" />
          <h1 className="text-2xl font-bold">Admin-Bereich</h1>
          <p className="mt-2 opacity-90">Bitte geben Sie das Passwort ein, um fortzufahren</p>
        </div>
        
        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-4 flex items-center">
              <SafeIcon icon={FiAlertCircle} className="text-red-500 mr-2" />
              {error}
            </div>
          )}
          
          <div className="space-y-2">
            <label htmlFor="password" className="block text-gray-700 font-medium">
              Admin-Passwort
            </label>
            <div className="relative">
              <SafeIcon 
                icon={FiLock} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
              />
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none"
                placeholder="Passwort eingeben"
                required
                autoFocus
              />
            </div>
            <p className="text-sm text-gray-500 mt-1">
              <SafeIcon icon={FiKey} className="inline mr-1" />
              Kontaktieren Sie den Administrator, wenn Sie keinen Zugang haben
            </p>
          </div>
          
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-orange-500 text-white font-bold py-3 px-6 rounded-xl hover:bg-orange-600 transition-colors flex items-center justify-center disabled:opacity-70"
          >
            {isSubmitting ? (
              <>
                <SafeIcon icon={FiLoader} className="animate-spin mr-2" />
                Überprüfe...
              </>
            ) : (
              <>
                <SafeIcon icon={FiLogIn} className="mr-2" />
                Anmelden
              </>
            )}
          </button>
          
          <div className="text-center text-sm text-gray-500">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="text-orange-500 hover:text-orange-700"
            >
              Zurück zur Burger-App
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;